<template>
  <div id="rose-chart">
    <div class="rose-chart-title">累计出库商品分布</div>
    <dv-charts :option="option" />
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'RoseChart',
  data () {
    return {
      option: {}
    }
  },
  methods: {
    initData() {
      let that = this
      axios({
        method:'get',
        url: that.baseUrl + "/datav/rose/chart/auth"
      }).then(function(resp){
        let res = resp.data;
        if (res.code === 200) {
          let data = res.data;
          that.option = {
            series: [
              {
                type: 'pie',
                radius: '50%',
                roseSort: false,
                data: [
                ],
                insideLabel: {
                  show: false
                },
                outsideLabel: {
                  formatter: '{name} {percent}%',
                  labelLineEndLength: 20,
                  style: {
                    fill: '#fff'
                  },
                  labelLineStyle: {
                    stroke: '#fff'
                  }
                },
                roseType: true
              }
            ],
            color: ['#da2f00', '#fa3600', '#ff4411', '#ff724c', '#541200', '#801b00', '#a02200', '#5d1400', '#b72700']
          }
          that.option.series[0].data = data;
          // *dataV里面的组件props均未设置deep监听，刷新props时，要直接生成新的props对象（基础数据类型除外），或完成赋值操作后使用ES6拓展运算符生成新的props对象
          that.option = { ...that.option }
        }
      }).catch(resp => {
        console.log('请求失败：' + resp.status + ',' + resp.statusText);
      });
    }
  },
  mounted () {
    const { initData } = this
    initData()
    setInterval(initData, 10000)
  }
}
</script>

<style lang="less">
#rose-chart {
  width: 30%;
  height: 100%;
  background-color: rgba(6, 30, 93, 0.5);
  border-top: 2px solid rgba(1, 153, 209, .5);
  box-sizing: border-box;

  .rose-chart-title {
    height: 50px;
    font-weight: bold;
    text-indent: 20px;
    font-size: 20px;
    display: flex;
    align-items: center;
  }

  .dv-charts-container {
    height: calc(~"100% - 50px");
  }
}
</style>
